module.exports = __webpack_public_path__ + "img/category-sport.2f5c88f0.png";